'use strict';

wbApp.controller('PreviewInterestCtrl', ['$scope', '$modal', '$q', 'semesterSvc', 'previewInterestSvc',
function ($scope, $modal, $q, semesterSvc, previewInterestSvc) {
    $scope.filterOptions = {
        filterText: ""
    };

    var activeSemesterPromise = semesterSvc.getDefaultAsync();
    // Wait for active semester
    activeSemesterPromise.then(function (activeSemester) {
        if (activeSemester) {
            $scope.semesterID = activeSemester.id;
        } else {
            $scope.semesterID = null;
        }

        $scope.previewInterests = previewInterestSvc.getAll(
            activeSemester != null ? activeSemester.id : null);
    });

    $scope.onSemesterChange = function (semesterId) {
        if (semesterId) {
            $scope.previewInterests = previewInterestSvc.getAll(semesterId);
            $scope.selectedRow = null;
        }
    }

    $scope.onRowSelected = function (data) {
        $scope.selectedRow = data;
    }

    $scope.gridOptions = {
        sortInfo: { fields: ['student'], directions: ['dsc'] },
        columnDefs: [{ field: 'student', displayName: "TXT_LBL_STUDENT", width: '140px' },
                          { field: 'course', displayName: "TXT_LBL_COURSE" },
                          { field: 'lesson', displayName: "TXT_LBL_LESSON", width: '110px', cellFilter: "date:'short'" },
                          { field: 'createdAt', displayName: "TXT_LBL_CREATED_AT", width: '110px', cellFilter: "date:'short'" }
        ]
    };

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "preview-interest/detail-tabs/home.html"
    }];

    $scope.tabs.activeTab = 0;

    $scope.onRowSelected = function (data) {
        $scope.selectedRow = data;
    }

    $scope.onRowEdit = function (data) {
        $scope.previewInterestDetail = angular.copy(data);

        $scope.previewInterestDetail.semesterID = $scope.semesterID;
        $scope.previewInterestDetail.courseID = data.courseID;
        $scope.previewInterestDetail.courseScheduleID = data.courseScheduleID;
        $scope.previewInterestDetail.interestID = data.id;

        $scope.previewInterestDetailOrig = angular.copy($scope.previewInterestDetail);

        detailDialogPromise.$promise.then(function () {
            $scope.detailError = null;
            detailDialogPromise.show();
        });
    }

    $scope.onPreviewInterestDetailSave = function (data) {
        
        $scope.detailError = null;

        previewInterestSvc.bookLesson(data,
            function (successResult) {
                detailDialogPromise.hide();
            }, function (errorResult) {
                $scope.detailError = errorResult;
            });
    }

    $scope.detailError = null;

    var detailDialogPromise = $modal({
        templateUrl: 'preview-hours/preview-interest-detail.html',
        show: false,
        scope: $scope
    });

}]);